import { render, staticRenderFns } from "./CustomInputHotKeys.vue?vue&type=template&id=e65a9b74&scoped=true&lang=pug&"
import script from "./CustomInputHotKeys.vue?vue&type=script&lang=js&"
export * from "./CustomInputHotKeys.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputHotKeys.vue?vue&type=style&index=0&id=e65a9b74&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65a9b74",
  null
  
)

export default component.exports